export default __webpack_public_path__ + "static/media/img-24.4a161300.jpg";